import { Player } from 'components/player';
import TwitchPlayer from '../TwitchPlayer';
export default function VideoEmbed({
  provider,
  postId,
  videoUrl,
  thumbnail,
  postUrl,
  title,
  creator,
  live,
  productType
}) {
  if (provider === 'fb') {
    return <div className="fb-wrapper">
        <iframe title={title} src={`https://www.facebook.com/plugins/post.php?href=${postUrl}&show_text=false&appId=542864969138098&width=896&height=560`} width="896" height="560" style={{
        border: 'none',
        overflow: 'hidden'
      }} scrolling="no" frameBorder="0"
      // eslint-disable-next-line react/no-unknown-property
      allowTransparency="true" allowFullScreen="true"></iframe>
      </div>;
  }
  if (provider === 'in') {
    return <div className="in-wrapper">
        <a href={postUrl} rel="noopener noreferrer" target="_blank">
          <img src={thumbnail} alt="title" />
        </a>
      </div>;
  }
  if (provider === 'tw') {
    return <TwitchPlayer live={live} postId={postId} creator={creator} productType={productType} />;
  }
  if (provider === 'tt') {
    return <div className="tt-wrapper">
        <iframe title={title} src={`https://www.tiktok.com/player/v1/${postId}?rel=0&closed_caption=0`} width="322" height="574" style={{
        border: 'none',
        overflow: 'hidden'
      }} scrolling="no" frameBorder="0"
      // eslint-disable-next-line react/no-unknown-property
      allowTransparency="true" allowFullScreen="true"></iframe>
      </div>;
  }
  return <Player url={videoUrl} />;
}